export const year2021 = [
  { year: 2021 },
  {
    name: 'Build Advanced Components with React Hooks',
    author: 'Matías Hernández',
    type: 'Course',
    link: 'https://egghead.io/courses/build-advanced-components-with-react-hooks-810906cc',
    repo: 'https://github.com/andreidobrinski/build-advanced-components-react-hooks-course-egghead'
  },
  {
    name: 'React: Building Progressive Web Apps (PWAs)',
    author: 'Eve Porcello',
    type: 'Course',
    link: 'https://www.linkedin.com/learning/react-building-progressive-web-apps-pwas/',
    repo: 'https://github.com/andreidobrinski/react-pwa-li-learning'
  },
  {
    name: 'Testing Library with Jest',
    author: 'Nicole C.',
    type: 'Workshop',
    link: 'https://www.meetup.com/torontojs/events/278340348/',
    repo: 'https://github.com/andreidobrinski/testing-library-codealong-june-8-2021'
  },
  {
    name: 'JavaScript Closures',
    author: 'Sasha Vodnik',
    type: 'Course',
    link: 'https://www.linkedin.com/learning/javascript-closures/',
    repo: 'https://github.com/andreidobrinski/closures-course-lil'
  },
  {
    name: 'Fullstack Advanced React and GraphQL',
    author: 'Wes Bos',
    type: 'Course',
    link: 'https://advancedreact.com/',
    repo: 'https://github.com/andreidobrinski/advanced-react-course-wb'
  },
  {
    name: 'PCI DSS: The State of Cardholder Data Attacks',
    author: 'Aaron Willis and John Elliott',
    type: 'Course',
    link: 'https://www.pluralsight.com/courses/pci-dss-state-cardholder-data-attack',
    repo: 'https://github.com/andreidobrinski/pluralsight-security-courses/blob/master/pci-dss-the-state-of-cardholder-data-attacks.md'
  },
  {
    name: 'Software and Systems Security for CompTIA CySA+',
    author: 'Dale Meredith ',
    type: 'Course',
    link: 'https://www.pluralsight.com/courses/software-systems-security-comptia-cysa-plus',
    repo: 'https://github.com/andreidobrinski/pluralsight-security-courses/blob/master/software-and-systems-security-for-comptia-cysa.md'
  },
  {
    name: 'Learn Svelte',
    author: 'Beau Carnes',
    type: 'Course',
    link: 'https://www.freecodecamp.org/news/svelte-video-tutorial/',
    repo: 'https://github.com/andreidobrinski/svelte-tutorial-freecodecamp',
  },
  {
    name: 'The Modern Angular Bootcamp [2020]',
    author: 'Stephen Grider',
    type: 'Course',
    link: 'https://www.udemy.com/course/the-modern-angular-bootcamp/',
    repo: 'https://github.com/andreidobrinski/modern-angular-bootcamp-udemy',
  },
  {
    name: 'The Complete React Native + Hooks Course [2020 Edition]',
    author: 'Stephen Grider',
    type: 'Course',
    link: 'https://www.udemy.com/course/the-complete-react-native-and-redux-course',
    repo: 'https://github.com/andreidobrinski/react-native-course-udemy-2020',
  },
  {
    name: 'Microfrontends with React: A Complete Developers Guide',
    author: 'Stephen Grider',
    type: 'Course',
    link: 'https://www.udemy.com/course/microfrontend-course/',
    repo: 'https://github.com/andreidobrinski/microfrontends-course-udemy',
  },
  {
    name: 'Building a widget using web components',
    author: 'Pradhumna Pancholi',
    type: 'Workshop',
    link: 'https://www.meetup.com/torontojs/events/ptxplrycccbqb',
    repo: 'https://github.com/andreidobrinski/eth-widget',
  },
  {
    name: 'Microservices with Node JS and React',
    author: 'Stephen Grider',
    type: 'Course',
    link: 'https://www.udemy.com/course/microservices-with-node-js-and-react/',
    repo: 'https://github.com/andreidobrinski/microservices-course-udemy',
  },
];
